import { useEffect } from "react";
import Pressable from "../../other/Pressable";

function PaintSetter({ submode, setSubmode, mode, setMode, paintColor, setColorPopupClosed, caixaSelected, setCaixaSelected, json, setJsonOutput, undo, canUndo, ...props }) {
    const exitMode = () => {
        setSubmode(null);
        setMode(null);
    };

    const togglePaint = () => {
        setCaixaSelected(-1);
        setSubmode(prev => prev === 'paint' ? null : 'paint');
    };

    const toggleErase = () => {
        setCaixaSelected(-1);
        setSubmode(prev => prev === 'remove' ? null : 'remove');
    };

    const openColorPicker = () => {
        setColorPopupClosed(false);
    };

    // Apply paint/erase when caixa is clicked
    useEffect(() => {
        if (caixaSelected === -1 || mode !== 'paint') return;

        const caixa = json?.[caixaSelected];
        if (!caixa || caixa.type !== 'caixa') return;

        if (submode === 'paint') {
            const fill = paintColor || '#ffffff';
            setJsonOutput(prev => {
                if (!prev?.[caixaSelected] || prev[caixaSelected].type !== 'caixa') return prev;
                return {
                    ...prev,
                    [caixaSelected]: {
                        ...prev[caixaSelected],
                        fill,
                        box: { ...prev[caixaSelected].box, fill }
                    }
                };
            });
        } else if (submode === 'remove') {
            setJsonOutput(prev => {
                if (!prev?.[caixaSelected] || prev[caixaSelected].type !== 'caixa') return prev;
                const { fill, ...rest } = prev[caixaSelected];
                const { fill: boxFill, ...boxRest } = rest.box || {};
                return {
                    ...prev,
                    [caixaSelected]: {
                        ...rest,
                        box: boxRest
                    }
                };
            });
        }

        setCaixaSelected(-1);
    }, [caixaSelected]);

    // Keyboard shortcuts
    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.ctrlKey || event.metaKey) return;
            if (event.target.tagName === 'INPUT' || event.target.tagName === 'TEXTAREA') return;

            if (event.key === 'p' || event.key === 'P') {
                togglePaint();
            } else if (event.key === 'Backspace' || event.key === 'Delete') {
                toggleErase();
            } else if (event.key === 'Escape') {
                if (submode) {
                    setSubmode(null);
                } else {
                    exitMode();
                }
            } else if (event.key === 'c' || event.key === 'C') {
                if (!event.metaKey && !event.ctrlKey) {
                    openColorPicker();
                }
            }
        };

        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [submode]);

    return (
        <>
            <Pressable className="boto" onClick={exitMode}>
                <span role="img" aria-label="back">⬅️</span>
            </Pressable>

            <Pressable
                className={`boto ${submode === 'paint' ? 'selected' : 'disabled'}`}
                onClick={togglePaint}
                title="Pintar (P)"
            >
                <span role="img" aria-label="paint">🖌️</span>
            </Pressable>

            <Pressable
                className={`boto ${submode === 'remove' ? 'selected' : 'disabled'}`}
                onClick={toggleErase}
                title="Esborrar color (DELETE)"
            >
                <span role="img" aria-label="erase">🧹</span>
            </Pressable>

            <Pressable
                className="boto"
                onClick={openColorPicker}
                title="Triar color (C)"
                style={{ border: `3px solid ${paintColor || '#ccc'}` }}
            >
                <span role="img" aria-label="color">🎨</span>
            </Pressable>

            <Pressable
                className={`boto ${!canUndo ? 'disabled' : ''}`}
                onClick={() => canUndo && undo()}
                title="Desfer (Ctrl+Z)"
            >
                <span role="img" aria-label="undo">↩️</span>
            </Pressable>
        </>
    );
}

export default PaintSetter;
